/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-named-as-default */
// eslint-disable-next-line import/no-named-as-default-member
import Request from 'api/request';

import { ApiPrefixV1, ApiV1Base } from 'util/icwUtility';
import qs from 'qs';

export const fetchCompanyById = (companyId) => {
  return Request.call({
    url: `/micro/companies/${companyId}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const updateCompanyInfo = (companyId, data) => {
  return Request.call({
    url: `/micro/companies/${companyId}`,
    method: 'PUT',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const updateCompanyTag = (companyId, tagIds) => {
  return Request.call({
    url: `/micro/companies/${companyId}/tags`,
    method: 'PUT',
    data: {
      tagIds,
    },
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const updateCompanySubCategory = (companyId, productSubCategoryIds) => {
  return Request.call({
    url: `/micro/companies/${companyId}/sub-categories`,
    method: 'PUT',
    data: {
      productSubCategoryIds,
    },
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const getCompanyCertifications = (companyId, params) => {
  const queryString = qs.stringify(params, {
    encodeValuesOnly: false,
    indices: false,
  });
  return Request.call({
    url: `/micro/companies/${companyId}/certifications?${queryString}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const createCompanyCertificate = (companyId, data) => {
  return Request.call({
    url: `/micro/companies/${companyId}/certifications`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const fetchCompanyDocuments = (companyId, params) => {
  const queryString = qs.stringify(params, {
    encodeValuesOnly: false,
    indices: false,
  });
  return Request.call({
    url: `/micro/companies/${companyId}/documents?${queryString}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const createCompanyDocuments = (companyId, documentLists) => {
  return Request.call({
    url: `/micro/companies/${companyId}/documents`,
    method: 'POST',
    data: {
      documentLists,
    },
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const deleteCompanyDocument = (companyId, documentListIds) => {
  return Request.call({
    url: `/micro/companies/${companyId}/documents`,
    method: 'DELETE',
    data: {
      documentListIds,
    },
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const deleteCompanyCertification = (companyId, certificationIds) => {
  return Request.call({
    url: `/micro/companies/${companyId}/certification`,
    method: 'DELETE',
    data: {
      certificationIds,
    },
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const fetchCompanyTags = async (params) => {
  const queryString = qs.stringify(params, {
    encodeValuesOnly: false,
    indices: false,
  });
  return Request.call({
    url: `/micro/tags?${queryString}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
